module.exports = __webpack_public_path__ + "img/6.21634abb.png";